import { Dispatch, PropsWithChildren, ReactElement, SetStateAction } from 'react'
import ButtonBlue from 'components/ui/button/_color/_blue'

import ButtonWhite from 'components/ui/button/_color/_white'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

type PopupStepperProps = {
  children: ReactElement[]
  onClose: () => void
  hideSteps?: boolean
  disabled?: boolean
  pagination?: {
    [property: number]: {
      removeRow?: boolean
      textNextBtn?: string
      textBackBtn?: string
      onClickNext?: () => void
      onClickBack?: () => void
      wrapBackBtn?: (props: PropsWithChildren<any>) => ReactElement
      wrapNextBtn?: (props: PropsWithChildren<any>) => ReactElement
      isLoading?: boolean
    }
  }
  step: number
  setStep: Dispatch<SetStateAction<number>>
  stepsCount?: number
}

export default function PopupStepper({
  children,
  onClose,
  hideSteps = false,
  pagination = {},
  step = 0,
  disabled,
  setStep,
  stepsCount = children.length
}: PopupStepperProps) {
  const { t, replacePlaceholders } = useTranslation()

  const handleNextStep = async () => {
    setStep((s) => {
      if (s === children.length - 1) {
        return s
      }
      return ++s
    })
  }

  const handlePreviousStep = async () => {
    setStep((s) => {
      if (!s) {
        return s
      }
      return --s
    })
  }

  const btnsGroupSelector = () => {
    if (children.length - 1 === step) {
      return (
        <ButtonBlue className={styles.btnNext} onClick={onClose}>{t('done')}</ButtonBlue>
      )
    }

    const WrapBackBtn = pagination[step]?.wrapBackBtn
    const WrapNextBtn = pagination[step]?.wrapNextBtn

    return (
      <>
        {step > 0 &&
          (WrapBackBtn ? (
            <WrapBackBtn>
              <ButtonWhite disableHover={true} className={styles.btnUnset}>
                {pagination[step]?.textBackBtn || 'Back'}
              </ButtonWhite>
            </WrapBackBtn>
          ) : (
            <ButtonWhite disableHover={true} className={styles.btnUnset} onClick={handlePreviousStep}>
              {pagination[step]?.textBackBtn || 'Back'}
            </ButtonWhite>
          ))}
        {WrapNextBtn ? (
          <WrapNextBtn>
            <ButtonBlue
              disabled={disabled}
              disableHover={true}
              className={styles.btnNext}
              isLoading={pagination[step]?.isLoading}
            >
              {pagination[step]?.textNextBtn || 'Next'}
            </ButtonBlue>
          </WrapNextBtn>
        ) : (
          <ButtonBlue
            disableHover={true}
            disabled={disabled}
            className={styles.btnNext}
            onClick={handleNextStep}
            isLoading={pagination[step]?.isLoading}
          >
            {pagination[step]?.textNextBtn || 'Next'}
          </ButtonBlue>
        )}
      </>
    )
  }
  return (
    <>
      {children[step]}
      {!pagination[step]?.removeRow && (
        <div className={styles.lastRow}>
          {hideSteps ? (
            <div />
          ) : (
            <div className={styles.step}>
              {replacePlaceholders(t('step_of'), { step: step + 1, length: stepsCount })}
            </div>
          )}

          <div className={styles.btnsWrapper}>{btnsGroupSelector()}</div>
        </div>
      )}
    </>
  )
}
